import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SecondaryButton from './SecondaryButton';
import Stepper from '@material-ui/core/Stepper';
import { withStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import PropTypes from 'prop-types';
import React from 'react';
import ActionText from '../core/ActionText';
import { UserConsumer } from '../core/providers/UserProvider';
import { ENTITLEMENTS } from '../core/utils/constants';
import CustomConnector from './CustomConnector';
import CustomStep from './CustomStep';
import PrimaryButton from './PrimaryButton';
import { globalStyles } from './style/gstheme';

const styles = () => {
    return Object.assign({
        stepper: {
            justifyContent: 'space-between',
            paddingBottom: '12px'
        }
    }, globalStyles);
};

class ImportStepper extends React.Component {

    state = {
        activeStep: 0
    };

    handleBack = () => {
        if (this.state.activeStep === 1 && this.props.handleReset) {
            this.props.handleReset();
        }
        else if (this.props.handleBack) {
            this.props.handleBack();
        }
        this.setState(state => ({ activeStep: state.activeStep - 1 }));
    };

    handleNext = () => {
        if (this.props.errored) {
            this.setState({ activeStep: 0 });
            this.props.onError();
            return;
        }
        const { activeStep } = this.state;
        if (activeStep === this.props.steps.length - 1) {
            this.setState({ activeStep: 0 });
            this.props.onComplete();
        }
        else {
            this.setState({ activeStep: activeStep + 1 });
        }
    };

    render() {

        const { classes, getStepContent, steps, canContinue, errored, importUnavailable } = this.props;
        const { activeStep } = this.state;

        if (activeStep === 0 && importUnavailable) return <div style={{ marginTop: 40 }}><ActionText>{importUnavailable}</ActionText></div>;

        return (
            <UserConsumer>
                {({ entitlements }) =>
                    entitlements.includes(ENTITLEMENTS.CAN_IMPORT) ?
                        <React.Fragment>
                            <Stepper activeStep={activeStep} connector={<CustomConnector />} className={classes.stepper}>
                                {steps.map((label, index) => {
                                    return (
                                        <CustomStep key={label} activeStep={activeStep} index={index} label={label} />
                                    );
                                })}
                            </Stepper>
                            {getStepContent(activeStep)}
                            <div style={{ float: 'right' }}>
                                <span style={{ marginRight: '20px' }}>
                                    {activeStep > 0 && this.props.canGoBack(activeStep) &&
                                        <SecondaryButton
                                            dataTest="previous-step"
                                            onClick={this.handleBack}
                                            className={classes.button}
                                            startIcon={<ArrowBackIcon />}>Previous</SecondaryButton>
                                    }
                                </span>
                                {canContinue(activeStep) ?
                                    <PrimaryButton onClick={this.handleNext}
                                        raised={true}
                                        endIcon={activeStep === steps.length - 2 ? <ArrowUpwardIcon /> : <ArrowForwardIcon />}>
                                        {activeStep < steps.length - 2 ? 'Next'
                                            :
                                            (
                                                activeStep === steps.length - 2 && !errored ? 'Upload'
                                                    :
                                                    'Finish'
                                            )}
                                    </PrimaryButton>
                                    :
                                    activeStep > 1 &&
                                    <PrimaryButton
                                        dataTest="please-wait"
                                        disabled={true}
                                        raised={true}
                                    >Please Wait</PrimaryButton>
                                }
                            </div>
                        </React.Fragment>
                        :
                        <ActionText>You do not have permission to perform imports.</ActionText>
                }
            </UserConsumer>
        );
    }
}

ImportStepper.defaultProps = {
    canContinue: true,
    error: false
};

ImportStepper.propTypes = {
    canContinue: PropTypes.func,
    canGoBack: PropTypes.func,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    onComplete: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    handleReset: PropTypes.func,
    handleBack: PropTypes.func,
    importUnavailable: PropTypes.string,
    errored: PropTypes.bool,
    getStepContent: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(ImportStepper);